import * as ActionTypes from '../actions/types/OnboardActionTypes';

const initialState = {
  step: 1,
  isSlugAvailable: true,
  primaryProduct: 'REGISTRY'
};

const onboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.INC_STEP: {
      return Object.assign({}, state, { step: state.step + 1 });
    }
    case ActionTypes.DEC_STEP: {
      return Object.assign({}, state, { step: state.step - 1 });
    }
    case ActionTypes.RESET_STEP: {
      return Object.assign({}, state, { step: 1 });
    }
    case ActionTypes.SLUG_AVAILABILITY_RECEIVED: {
      return Object.assign({}, state, { isSlugAvailable: action.payload });
    }
    case ActionTypes.SLUG_SUGGESTIONS_RECEIVED: {
      return Object.assign({}, state, { slugSuggestions: action.payload });
    }
    case ActionTypes.PRIMARY_PRODUCT_SELECTED: {
      return Object.assign({}, state, { primaryProduct: action.payload });
    }
    default: return state;
  }
};

export default onboardReducer;



// WEBPACK FOOTER //
// ./src/reducers/onboard.js